var PNHeaderV2,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../../../../../core/frontend/groupon_modules/ariaKeyNavigation');

require('../../../../../modules/gig_body/header/frontend/views/pn_primarynav');

module.exports = PNHeaderV2 = (function(superClass) {
  extend(PNHeaderV2, superClass);

  function PNHeaderV2($el) {
    this.$el = $el;
    this.$primaryNav = this.$el.find('.primary-nav');
    this.initialize();
  }

  PNHeaderV2.prototype.initialize = function() {
    if (!$('#ls-lite-header').length) {
      return new Groupon.LS.Header.PNPrimaryNav(this.$primaryNav);
    }
  };

  PNHeaderV2.prototype.bind = function() {
    var $userMenu, $userName;
    if (($userName = $('.user-name')).length) {
      $userMenu = $('#ls-my-stuff');
      if (Groupon.LS.hasTouch) {
        return $userName.off('tap').on('tap', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          $userMenu.toggle();
          $userMenu.attr('aria-hidden', $userMenu.attr('aria-hidden') !== 'true');
          $('html').trigger('tap');
          if ($userMenu.is(':visible')) {
            return $('html').off('tap').one('tap', function(e) {
              if ($(e.target).closest('.user-name, .my-stuff').length === 0) {
                return $userMenu.hide().attr('aria-hidden', 'true');
              }
            });
          }
        });
      } else {
        return this.initMenuNavigation($userName, $userMenu, $userMenu.find('a'));
      }
    }
  };

  return PNHeaderV2;

})(Groupon.AriaMenuNavigation);

